import React from "react";
import "./style.css";
import avtar from "../../../assests/emotion1.png";
import { Link } from "react-router-dom";

export const Loginpopup = () => {
  return (
    <div className="login-popup-container">
      <div className="login-popup">
        <div className="login-popup-header">
          <img className="login-popup-image" src={avtar} alt="Congratulations" />
        </div>
        <div className="login-popup-content">
          <p className="login-popup-title">Congratulations</p>
          <span className="login-popup-message">Password changed successfully.</span>
        </div>
        <div className="login-popup-button">
          <Link to="/" className="login-popup-link">
            <p className="login-popup-button-text">Login</p>
          </Link>
        </div>
      </div>
    </div>
  );
};